import { useAssessmentContext } from '../context/AssessmentContext';
import questionsData from '../data/questions.json';
import { AssessmentData } from '../types';

const data = questionsData as AssessmentData;

export const useAssessment = () => {
  const { answers, setAnswer, resetAssessment, isComplete, setIsComplete, userInfo, setUserInfo } = useAssessmentContext();

  const totalQuestions = data.dimensions.reduce((acc, dim) => acc + dim.questions.length, 0);
  const answeredCount = Object.keys(answers).length;
  const progress = (answeredCount / totalQuestions) * 100;

  return {
    dimensions: data.dimensions,
    assessmentTitle: data.assessmentTitle,
    answers,
    setAnswer,
    resetAssessment,
    progress,
    isComplete,
    setIsComplete,
    totalQuestions,
    answeredCount,
    userInfo,
    setUserInfo
  };
};
